import React from "react"
import { Headline } from "@shared"
import { PageSection } from "@components/sections/PageSection"
import { CONSTANTS } from "@data"
// import { css } from "@jsUtils"

import Styles from "./technologyLanding.module.scss"

const { THEMES } = CONSTANTS
const nobr = {
  whiteSpace: "nowrap"
}

const TechnologyLanding = () => {
  return (
    <PageSection className={Styles.section} theme={THEMES.BLACK}>
      <div className={Styles.content}>
        <div className={Styles.firstSection}>
          <div>
            <Headline className={Styles.firstHeadline} size={1}>
              The most advanced ultrasound silicon in <span style={nobr}>the world</span>
            </Headline>
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export default TechnologyLanding
